(function($){
	$(document).ready(()=>{
		const attCookie = $.cookie('technolove-cookie-attention');
		if (attCookie != null) return false;

		const date = new Date();
		const finishDate = new Date(2022, 0, 16);

		if (date < finishDate) {
			setTimeout(initAttention, 500);
		}

		function initAttention() {
			$.magnificPopup.open({
				items: { src: $('#attention'), type: 'inline', },
				callbacks: {
					close: function() {
						$.cookie('technolove-cookie-attention', 'technolove-cookie-attention-success',
							{ expires: 7, path: '/',}
						);
					},
				},
			});
		}
	});
	// eslint-disable-next-line no-undef
})(jQuery);
